export default {
  overline: {
    id: 'shopping_assistant_fab_overline',
    defaultMessage: 'Need help?',
  },
  message: {
    id: 'shopping_assistant_fab_message',
    defaultMessage: 'Ask us',
  },
  ariaLabel: {
    id: 'shopping_assistant_fab_aria_label',
    defaultMessage: 'Open Back Market AI',
  },
} as const
